// Overrides del tema por defecto de naive-ui para alinearlo
// con la paleta de Frases Melón (ver src/assets/theme.css).
export const naiveThemeOverrides = {
  common: {
    primaryColor: '#FF7A59',
    primaryColorHover: '#E8613F',
    primaryColorPressed: '#C94F30',
    fontFamily: "'Inter', sans-serif",
    borderRadius: '10px',
  },
  Dropdown: {
    color: '#FFFDF8',
    optionColorHover: '#FBEADD',
    optionTextColor: '#2B2018',
    dividerColor: '#E7D9BC',
  },
};
